export default __webpack_public_path__ + "static/labatt-e5453ad1967d60d0e847704e8a0e2288.svg";